import StorageService from './storage.service';

const TOKEN_KEY = 'TOKEN';

const TokenService = {
  getToken() {
    return StorageService.get(TOKEN_KEY);
  },
  saveToken(token) {
    StorageService.set(TOKEN_KEY, token);
  },
  removeToken() {
    StorageService.remove(TOKEN_KEY);
  },
};

export default TokenService;
